import { Alert, Box, Container, Typography } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useSimulatorExercises } from '../../../api';
import AppBar from '../../../app-bar/AppBar';
import consoleSvg from '../../../assets/console.svg';
import BackLink from '../../../back-link/BackLink';
import ExerciseCard from '../../../exercise-card/ExerciseCard';
import ExerciseCardSkeleton from '../../../exercise-card/ExerciseCardSkeleton';
import Fallback from '../../../fallback/Fallback';

const QRResults = () => {
  const { simulatorId } = useParams();
  const { exercises, loadingExercises, exercisesError } = useSimulatorExercises({ simulatorId });

  return (
    <>
      <AppBar />
      <Container>
        <BackLink label="Back to Home" sx={{ display: { xs: 'inline-block', sm: 'none' }, my: 2 }} to="/" />
        <Typography component="h1" variant="h4" mb={4} mt={3}>
          Detected exercises for scanned simulator
        </Typography>

        {loadingExercises ? (
          <>
            <ExerciseCardSkeleton />
            <ExerciseCardSkeleton />
          </>
        ) : exercisesError ? (
          <Fallback
            imgSrc={consoleSvg}
            message={
              <Alert severity="error">
                Something went wrong and we couldn&lsquo;t load your exercises. Please try again
              </Alert>
            }
          />
        ) : exercises ? (
          <Box
            sx={{ display: 'grid', gridTemplateColumns: { sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' }, gap: 3, mb: 3 }}
          >
            {exercises?.map(exercise => (
              <ExerciseCard
                {...exercise}
                showKSim={false}
                key={exercise.id}
                to={`/learn/exercises/${exercise.id}`}
                showTimeDetails
              />
            ))}
          </Box>
        ) : null}
      </Container>
    </>
  );
};

export default QRResults;
